import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = ({ children }) => {
  const { user, isAuthLoading } = useAuth();

  // If the app is still quietly pinging /me, don't kick them out yet!
  if (isAuthLoading) {
    return <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", background: "#0c0c0c" }}>Authenticating...</div>;
  }

  // If there is no user in memory, or the role is not Admin, kick them back to login
  if (!user || user.role.toUpperCase() !== "ADMIN") {
    return <Navigate to="/log-in" replace />;
  }

  return children;
};

export default AdminRoute;